/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-03-08T19:23:44.961
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listFinancialClaimCancellationApplyItem,
	listFinancialClaimCancellationApplyItemInit,
	listFinancialClaimCancellationApplyItemByAuthorizations,
	deleteFinancialClaimCancellationApplyItem
} from '@api/financial/FinancialClaimCancellationApplyItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listFinancialClaimCancellationApplyItem({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialClaimCancellationApplyItem(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialClaimCancellationApplyItemByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialClaimCancellationApplyItemByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialClaimCancellationApplyItemInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialClaimCancellationApplyItemInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinancialClaimCancellationApplyItem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancialClaimCancellationApplyItem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
